'use strict';

/**
 * justHeight
 */
export const justHeight = (() => {
    let winH = 0;
    let navH = 0;

    /**
     * init
     */
    const init = () => {
        adjust();

        $(window).on('load resize', function () {
            adjust();
        });
    };

    const adjust = () => {
        if ($(window).outerWidth() <= 768) {
            winH = window.innerHeight;
            navH = winH - $('.js-header').height();
            $('.js-just-nav').height(navH);
        } else {
            $('.js-just-nav').height('auto');
        }
    };

    // public
    return {
        init: init
    };
})();
